const common = {
  "nav.home": "首页",
  "nav.categories": "分类",
  "nav.about": "关于我们",
  "nav.articles": "文章",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.article": "文章",
  "breadcrumb.about": "关于我们",
  "button.readMore": "阅读全文",
  "button.viewAll": "查看全部",
  "button.subscribe": "订阅",
  "button.submit": "提交",
  "button.loadMore": "加载更多",
  "footer.copyright": "黄油游戏官方指南。保留所有权利。",
  "footer.description": "黄油游戏官方指南致力于为玩家提供最全面的黄油游戏攻略、推荐与玩法教程，帮助每一位玩家找到属于自己的沉浸式游戏体验。",
  "footer.quickLinks": "快速链接",
  "footer.categories": "内容分类",
  "footer.contact": "联系我们",
  "footer.newsletter": "订阅资讯",
  "footer.newsletterDesc": "获取最新黄油游戏攻略与推荐",
  "footer.emailPlaceholder": "输入您的邮箱",
  "search.placeholder": "搜索文章、攻略、游戏...",
  "article.readTime": "分钟阅读",
  "article.relatedArticles": "相关推荐",
  "article.share": "分享",
  "category.all": "全部",
  "form.subscribeSuccess": "订阅成功！感谢您的关注。",
  "form.subscribeError": "订阅失败，请稍后重试。",
  "form.emailRequired": "请输入有效的邮箱地址",
};

export default common;